export const Complete = 1;
export const Alert = 2;
export const ThreeDs = 3;
export const Error = 4;
export const ValidationError = 5;
export const TimedOut = 6;
export const BookingError = 7;
export const PayPalVerification = 8;
export const PayPalVerified = 9;
export const Cpg = 10;
export const Refresh = 13;
